import './App.css';
import SectionOne from './components/sectionOne/SectionOne';
import SectionThree from './components/sectionThree/SectionThree';
import SectionTwo from './components/sectionTwo/SectionTwo';

function App() {
  return (
    <div className="App">
      <SectionOne />
      <SectionTwo />
      <SectionThree />
    </div>
  );
}

export default App;
